import React from 'react';

export default function CalendarFilled(): JSX.Element {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginLeft: '6px',
      }}
    >
      <path
        d="M1.03125 5C0.867188 5 0.75 5.14062 0.75 5.28125V11.375C0.75 12.0078 1.24219 12.5 1.875 12.5H10.125C10.7344 12.5 11.25 12.0078 11.25 11.375V5.28125C11.25 5.14062 11.1094 5 10.9688 5H1.03125ZM11.25 3.96875V3.125C11.25 2.51562 10.7344 2 10.125 2H9V0.78125C9 0.640625 8.85938 0.5 8.71875 0.5H7.78125C7.61719 0.5 7.5 0.640625 7.5 0.78125V2H4.5V0.78125C4.5 0.640625 4.35938 0.5 4.21875 0.5H3.28125C3.11719 0.5 3 0.640625 3 0.78125V2H1.875C1.24219 2 0.75 2.51562 0.75 3.125V3.96875C0.75 4.13281 0.867188 4.25 1.03125 4.25H10.9688C11.1094 4.25 11.25 4.13281 11.25 3.96875Z"
        fill="#00A4E4"
      />
    </svg>
  );
}
